import { Hero } from "../components/home/Hero";
import { TrustStrip } from "../components/home/TrustStrip";
import { ServicesBento } from "../components/home/ServicesBento";
import { Solutions } from "../components/home/Solutions";
import { DigitalMarketing } from "../components/home/DigitalMarketing";
import { Stats } from "../components/home/Stats";
import { Gallery } from "../components/home/Gallery";
import { Clients } from "../components/home/Clients";
import { Press } from "../components/home/Press";
import { CtaBand } from "../components/CtaBand";
import { ContactSection } from "../components/ContactSection";
import { usePageMeta } from "../hooks/usePageMeta";

const toQuote = () => {
  const el = document.getElementById("preventivo");
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -100 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Home() {
  usePageMeta(
    "Nuova Giga Print | Stampa, Allestimenti, Creatività e Digital Marketing a Roma",
    "Comunicazione visiva su misura, dalla stampa all'allestimento. Stampa digitale, offset, serigrafia, allestimenti, gadget e digital marketing a Roma."
  );
  return (
    <>
      <Hero onQuote={toQuote} />
      <TrustStrip />
      <ServicesBento />
      <Solutions />
      <DigitalMarketing />
      <Stats />
      <Gallery />
      <Clients />
      <Press />
      <CtaBand onClick={toQuote} />
      <ContactSection />
    </>
  );
}
